import dailyCoCore from "./dailyco.core";
import dom from "./dom-util";
import createForm from "./customer-form";
import common from './common-util';
import config from './config';
import dealer from './dealer';
import eventListners from './eventListners';
import sdAnalytics from './sdAnalytics';

class app {
  cssUrl = "https://web.tagrail.com/online/portal/scripts/tg-video-chat/tg-dailyco-video-chat.css";

  constructor() {
    const {
      setup,
      joinMeeting,
      showChatWindow,
    } = this;

    let initialized = window.tgVChatInit && window.tgVChatInit === 0;
    if (!initialized) {
      console.log("TR : Setting up Video chat");
      if (process.env.NODE_ENV === "development") {
        window.tgDealer = {
          dealerId: "9687",
        };
      }

      if (process.env.NODE_ENV === "production") {
        common.injectCSS(this.cssUrl);
      }

      window.tgDealerId = window.tgDealer? window.tgDealer.dealerId : sessionStorage.getItem("tgdealerId");

      dealer.createChatSessionId();
      window.joinMeeting = joinMeeting;
      window.showChatWindow = showChatWindow;

      (async function () {
        await setup();
      })();
    } else {
      console.log("TR : Video chat state - initialized");
    }
  }
  setup = async function () {

    let dealerId = window.tgDealerId;
    let dailyCoCoreObj = new dailyCoCore();
    let settings = await dealer.getChatClientSettingsAsync(dealerId);
    await dealer.getDefaultUser(dealerId);
    if (settings) {
      eventListners.listen();
      let joinMeetingDiv = document.getElementById("#tg-join-meeting");
      if (joinMeetingDiv) {
        joinMeetingDiv.remove();
      }

      if (!dailyCoCoreObj.isMeetingActive()) {
        if (settings.uiSettings.showChatIcon) {
          let chatIcon = settings.uiSettings.chatIcon ? settings.uiSettings.chatIcon : 
            '<div><a id="tg-join-meeting-icon" style="" class="animated pulse" href="javascript:void(0)" onclick="joinMeeting();"><div style="text-align: center;"><img src="https://web.tagrail.com/online/portal/scripts/tg-video-chat/assets/icon.png" style="margin: 20%;width: 40px;display: inline-block;"></div></a></div>';
          let divbutton = dom.createElementFromHTML(chatIcon);
          document.body.appendChild(divbutton);
        }
      }

      dailyCoCoreObj.createVideoWrapper(null);

      dailyCoCore.keepChatInProgressIcon();
      window.tgVChatInit = 1;
      let sd = new sdAnalytics();
      sd.sdAnalyticsInitialize(settings);
    }
  }

  joinMeeting = function (event) {
    let meetingState = window.tgMeetingState ? window.tgMeetingState : "inactive";
    let invitedBy = {};
    let parentPopupId = null;
    let parentIframeId = null;
    let customerObject = null;
    let dealerId = window.tgDealerId;
    let sessionId = dealer.getChatSessionId();
    let hasCustomerInfo = true;
    let data = null;
    let dailyCoCoreObj = new dailyCoCore();


    let getCustomerInforamtion = function (event) {

      let customer = null;
      if (event && event.data && event.data.customer) {
        customer = event.data.customer;
      } else {
        var customerInfoFromSession = dealer.getCustomerInfoFromSession();
        if (customerInfoFromSession) {
          customer = customerInfoFromSession.customer;
        }

      }
      return customer;
    };

    let eventDataPresent = event && event.data;
    let isPopupActive = dealer.isPopupActive();
    customerObject = getCustomerInforamtion(event);

    if (eventDataPresent && isPopupActive) {
      data = event.data;
      parentPopupId = data.popupId;
      parentIframeId = data.iframeId;
      dealer.setCustomerInSession(data);
    }

    if (customerObject == null || (customerObject && customerObject.fName === "")) {
      hasCustomerInfo = false;
      let customerFormParentId = config.videocallwrapperdivId; 
      if(parentPopupId)
      {
        customerFormParentId = parentPopupId;
      }
      createForm(customerFormParentId);
      dom.hide(config.tgvideoIconId);
      dom.setStyle(config.customerFromId, { 'visibility': 'visible', 'opacity': 1, 'transition': 'all 0.5s', 'transform': 'translate(0)' });
    }

    if (hasCustomerInfo && (!meetingState || meetingState === "left-meeting" || meetingState === "inactive")) {
      invitedBy.firstName = customerObject.fName;
      invitedBy.lastName = customerObject.lName;
      if (common.isMobile()) {
        if (isPopupActive) {
          dom.setStyle(parentPopupId, { 'display': 'none', });
        }
        dailyCoCoreObj.setupDailyFrame(parentPopupId);
      }
       else {
        new dailyCoCore().openEmptyFrameInNewWindow();
      }

      dailyCoCoreObj.createRoom(dealerId, sessionId, {
        customerFirstName: customerObject.fName,
        customerLastName: customerObject.lName
      }).then(function (response) {
        if (response && response.success === 1) {

          dailyCoCoreObj.setMeetingState("active");
          dailyCoCoreObj.setChatRoomState("active");
          window.tgRoomName = response.result.name;
          window.tgChatRoomId = response.result.roomId;
          let tgPopupSessionId = window.tgSessionId;
          let meetingUrl = response.result.url;
          if (common.isMobile()) {
            dailyCoCoreObj.joinRoom(meetingUrl);
          } else {
            dailyCoCoreObj.openFrameInNewWindow(meetingUrl);
          }
          dailyCoCoreObj
            .inviteUser(
              dealerId,
              sessionId,
              tgPopupSessionId,
              invitedBy
            )
            .then(function (invitedResponse) {
              console.log(invitedResponse.result);
            });
        }
      });
    }


  }

  showChatWindow = function () {
    new dailyCoCore().windowBringToTop(window.tgmeetingChildWindow);
  }


}

export default app;